const ko = {
  시작하기: '시작하기',
  다운로드: '다운로드',
  '수신자 이메일이 설정되지 않았습니다. 관리자에게 문의하세요.':
    '수신자 이메일이 설정되지 않았습니다. 관리자에게 문의하세요.',
  Voucher: '바우처',
  'RAYTeams Cloud Platform is building an amazing ecosystem specialized in Dental Services.':
    'RAYTeams Cloud Platform은 Dental Service에 있어 뛰어난 생태계를 구축할 수 있습니다.',
  'Join the RAYTeams Cloud and get started.': 'RAYTeams Cloud를 시작해보세요!',
  'Explore more': '더 알아보기',
  'Open Platform for Anyone': '오픈 플랫폼',
  'RAYTeams Cloud Platform is an open platform that anyone can participate in.':
    'RAYTeams Cloud Platform은 누구나 참여가능한 오픈 플랫폼입니다.',
  'Simple & Powerful Workflows': '심플하고 강력한 워크플로우',
  'Create, use, or provide the workflow for your organization as an app.':
    '다양한 앱들을 통해서 워크플로우를 이용하여 쉽게 사용이 가능합니다.',
  'Global Partner & Community': 'Global Partner & Community',
  'Try RAYTeams Apps, provided or collaborated with Global Patner.':
    '다양한 RAYTeams App을 통해서 Global Patner와 협업해보세요.',
  'Customize & Flexable Platform': '유연한 커스터마이징 플랫폼',
  'Provides powerful customization for hospitals and clinic.':
    '매우 강력한 커스터마아징 기능을 제공합니다.',
  'RAYTeams CLIENT DOWNLOAD': 'RAYTeams Client 다운로드',
  'The RAYTeams Client is the default client software required when using the RAYTeams Cloud Platform.':
    'RAYTeam Client는 RAYTeams Cloud Platform을 이용하기 위한 필수 소프트웨어 입니다.',
  'Client Download': '클라이언트 다운로드',
  MANUAL: '메뉴얼',
  'Do you need any questions or instructions for installing RAYTeams?':
    'RAYTeams 관련하여 궁금한 사항이 있나요?',
  'Please check out the manual.': '메뉴얼을 확인해보세요.',
  'more view': '더보기',
  "WHAT'S NEW": "WHAT'S NEW",
  "Let's take a look at the new features of RAYTeams.": 'RAYTeams의 새로운 기능을 살펴보세요.',
  "Please check out the what's new.": '달라진점 확인해보기',
  'Whatever the Dental Service needs,': 'Dental Service의 모든 것,',
  'RAYTeams Cloud Platform provides an excellent service experience.':
    'RAYTeams Cloud Platform은 탁월한 서비스 경험을 제공합니다.',
  'RAYTeams Cloud Platform is...': 'RAYTeams Cloud Platform은...',
  'Anyone can easily create and introduce the RAYTeams App to multiple users.':
    '누구나 쉽게 이용할 수 있으며, 다양한 RAYTeams App을 통해서 다른 사용자들과 협업할 수 있습니다.',
  'To that end, RAYTEAMS Cloud': 'RAYTeams Cloud',
  'There are several workflows in dentistry and dental lab.':
    '치과에서는 많은 치료 관련 워크플로우가 있습니다.',
  'There are also workflows based on treatment methods such as correction, prosthetics, denture, etc., and there are various workflows such as pore delivery, schedule management, and simple to do management.':
    '보철, 교정, 덴처 등 다양한 치료 방법에 대한 효과적인 워크플로가 준비되어있습니다.',
  'Workflows provided by several related apps are available, and you can also create and use or provide a workflow that fits your organization directly into an app.':
    '관련된 여러 워크플로우는 앱을 사용하여 효과적이고 직관적으로 사용할 수 있습니다.',
  'The RAYTeams Cloud Platform is based in 13 regions worldwide.':
    'RAYTeams Cloud Platform은 전세계 13개의 지역에 서버를 두고 있습니다.',
  'A variety of services are available using RAYTeams Apps provided or collaborated with Global Patner.':
    '글로벌 파트너 또는 RAYTeams App에서 제공하는 다양한 서비스를 이용할 수 있습니다.',
  'In addition, it provides a powerful community so that you can share and view effective and diverse information.':
    '또한, 강력한 커뮤니티를 통해서 다양한 정보도 얻을 수 있습니다.',
  'The RAYTeams Cloud Platform provides powerful customization for large hospitals and large air stations. You can also build another ecosystem of your own.':
    'RAYTeams Cloud Paltform은 강력한 커스터마이징을 제공합니다. 대형 기공소/치과의 경우, 더욱더 다양한 기능이 제공됩니다. 대형 기관의 경우, 자신만의 Platform 생태계를 구성할 수도 있습니다.',
  'You can build a RAYTEAMS Cloud Platform specifically for a specific hospital or a specific laboratory to provide services.':
    'RAYTeams Cloud Platform에는 파터너를 위한 특정 기공소/치과에 대한 매니지먼트 기능도 포함되어 있습니다.',
  'Email verification has been completed.': '이메일 인증이 완료되었습니다.',
  'Email verification failed.': '이메일 인증에 실패했습니다.',
  'Email verification': '이메일 인증',
  'We are currently in the process of email verification.': '이메일 인증을 진행하고 있습니다.',
  'Verification has been completed. You may now close this window.':
    '인증이 완료되었습니다. 이 창은 이제 닫아도 됩니다.',
  'You have accessed this page through an incorrect path.':
    '잘못된 경로로 이 페이지에 접근했습니다.',
  'You have accessed this page through an invalid method.':
    '올바르지 않은 방법으로 이 페이지에 접근했습니다.',
  'Please try again in a moment.': '잠시 후 다시 시도해 주세요.',
  'The email verification time has expired. Please request another verification email.':
    '이메일 인증 시간이 만료되었습니다. 다시 인증메일을 받아주세요.',
  'There is no requested verification.': '요청된 인증이 없습니다.',
  "We couldn't find the user who requested the verification.":
    '인증을 요청한 사용자를 찾을 수 없습니다.',
  'An error has occurred. Please try again later.':
    '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  'This email is different from the one you requested.': '요청한 이메일과 다른 이메일입니다.',
  'The current request is incorrect. If you have requested email verification multiple times, please check the latest email.':
    '현재 요청은 잘못된 요청입니다. 만약 여러번 인증 메일을 요청했다면 최신의 메일을 확인해주세요.',
  '구독 관리': '구독 관리',
  Subscription: '구독',
  Purchase: '구매',
  'This product is paid periodically after purchase.': '이 상품은 구매 후 주기적으로 결제됩니다.',
  'Right now, this product is being applied at a discounted price.':
    '지금 이 상품은 할인된 가격이 적용 중입니다.',
  Paypal: '페이팔',
  Toss: '토스',
  'Includes Trial': '평가판 포함됨',
  'Without Trial': '평가판 미포함',
  'This product is available for free trial for {{trialPeriod}} days.':
    '이 상품은 {{trialPeriod}}일 동안 무료로 평가판 사용이 가능합니다.',
  'After a {{trialPeriod}}-day trial, billing starts, then recurs every {{subPeriod}} days.':
    '{{trialPeriod}}일의 무료 평가판 기간 이후에 결제가 시작되며, 이후로는 {{subPeriod}}일마다 결제됩니다.',
  'Billing every {{subPeriod}} days': '{{subPeriod}}일 마다 결제',
  'Check {{appTitle}} details': '{{appTitle}} 상세 정보 확인',
  'Billing cycle': '결제 주기',
  'Whether to include a trial': '평가판 포함 여부',
  'Payment amount': '결제 금액',
  'Payment Type': '결제 유형',
  'Product information': '상품 정보',
  'Do you want to cancel the payment and go to the detailed screen of the app?':
    '결제를 취소하고 앱의 상세 화면으로 이동하시겠습니까?',
  'Billing every {{subPeriod}} days.': '{{subPeriod}}일 마다 결제',
  'You can cancel the subscription for this product at any time.':
    '이 상품은 언제든 구독을 취소할 수 있습니다.',
  'Your account has already utilized the free trial period on {{date}}.':
    '귀하의 계정은 이미 {{date}}에 무료 체험 기간을 사용했습니다.',
  'Please wait...': '기다려 주세요',
  'Business number': '사업자등록번호',
  'Mail order sales approval number': '통신판매업신고번호',
  CEO: '대표이사',
  'Sang Chul Lee': '이상철',
  Email: '이메일',
  Address: '주소',
  '12 Floor, TWOSUN WORLD Bldg, 221 Pangyoyeok-ro, Bundang-gu Seongnam-si, Gyeonggi-do Republic of Korea':
    '경기도 성남시 분당구 판교역로 221(삼평동 672) 투썬월드빌딩 12층',
  Phone: '대표전화',
  '+82 (31) 605-1000': '031-605-1000',
  RAY: '주식회사 레이',
  Notice: '공지사항',
  'Privacy Policy': '개인정보처리방침',
  'Terms and Conditions': '이용약관',
  'The automatic payment date may vary slightly depending on the payment gateway provider.':
    '자동 결제일시는 결제 대행 업체에 따라 조금씩 차이가 발생할 수 있습니다.',
  'Minor bugs have been fixed and usability has been improved.':
    '사소한 버그가 수정되었고 사용성이 향상되었습니다.',
  'Open Platform for Healthcare Professionals': '의료(치과) 종사자들을 위한 오픈 플랫폼',
  'RAYTeams Cloud Platform is an open platform for healthcare professionals':
    'RAYTeams는 의료(치과) 종사자들을 위한 강력한 오픈 플랫폼입니다.',
  'payment.result.ok': '확인',
  '{{trialPeriodStr}} 이후 {{price}}{{currency}} / {{paymentCycle}} 결제':
    '이후 {{price}}{{currency}} / {{paymentCycle}} 결제',
  'Please wait a second...': '잠시만 기다려주세요...',
  AGREE: '동의',
  "Don't show this window again.": '이 창을 다시 열지 않음',
  Status: '상태',
  'Payment Status': '결제 상태',
  'Collected items': '수집 항목',
  'Purpose of use': '이용 목적',
  "Institution's name": '기관 이름',
  'Search institutions to create a case': '케이스 생성을 위한 기관 조회',
  "Display Institution's name for chatting": '채팅을 위한 기관 이름 표시',
  '(Optional) I agree to receive marketing information.':
    '(선택) 나는 마케팅 정보 수신에 동의합니다.',
  'Agreement to receive marketing information': '마케팅 정보 수신 동의',
  'Refusal to receive marketing information': '마케팅 정보 수신 거절',
  'Would you like to consent to receiving marketing information?':
    '마케팅 정보 수신에 동의하시겠습니까?',
  'Would you like to refuse consent for receiving marketing information?':
    '마케팅 정보 수신 동의를 거절하시겠습니까?',
  Agreed: '동의됨',
  Disagreed: '미동의',
  'button.marketing.toDisagree': '마케팅 수신 동의 철회',
  'button.marketing.toAgree': '마케팅 수신 동의',
  'Receive Marketing Information': '마케팅 정보 수신',
  'Please authenticate below to subscribe for an extension.':
    '구독을 연장 하려면 아래 인증을 해주세요.',
  'Subscription extension': '구독 연장',
  'Subscription extension has been completed.': '구독 연장이 완료되었습니다.',
  'The subscription extension has already been completed.': '이미 구독 연장이 완료되었습니다.',
  'No subscription extension request': '구독 연장 신청이 없습니다.',
  'License Key': '라이선스 키',
  'License Registration Info': '라이선스 등록 정보',
  'No Registration record': '등록 이력이 없습니다.',
  'Registration Date': '등록 일시',
  'Last Used': '최근 사용일',
  Show: '보기',
  Hide: '감추기',
  Copy: '복사',
  'Payment Methods Management': '결제 수단 관리',
  'Payment Methods': '결제 정보',
  'No payment Methods registered.': '등록된 결제 수단이 없습니다.',
  'Payment Service': '결제 서비스',
  'Card Type': '카드 종류',
  'Card Number': '카드 번호',
  'Change Payment Method': '결제 수단 변경',
  'Would you like to delete the selected payment method?': '선택한 결제 수단을 삭제 하시겠습니까?',
  'Delete payment method': '결제 수단 삭제',
  'Would you like to change the selected payment method?':
    '선택한 결제 수단으로 변경 하시겠습니까?',
  'Service Page': '서비스 페이지',
  'This site complies with the General Data Protection Regulation (EU 2016/679).':
    '본 사이트는 개인정보 보호 법령(EU 2016/679)을 준수합니다.',
  'This site meets the requirements of the General Data Protection Regulation (EU 2016/679).':
    '본 사이트는 개인정보 보호 법령(EU 2016/679) 요건 충족합니다.',
  'the content of this site is protected against unauthorized modification.':
    '본사이트의 콘텐트는 무단 변조로부터 보호됩니다.',
  'Previous versions of the User Manual are available for viewing and downloading via search.':
    '사용자 매뉴얼의 이전 버전은 검색을 통해 확인 및 다운로드 가능합니다.',
  'IDS Annual Pass': 'IDS Annual Pass',
  'Available immediately after product registration.': '제품 등록 후, 바로 사용 가능합니다.',
  'Redeem Code': 'Redeem Code',
  'Product Registration': '제품 등록',
  'The following software will be activated.': '아래의 소프트웨어들이 활성화됩니다.',
  'Product Registration Complete': '제품 등록 완료',
  'Product registration has been completed.': '제품 등록이 완료되었습니다.',
  'Usage Guide': '사용방법 안내',
  '1. Install/Login RAYTeams on PC': '1. PC에 RAYTeams 설치/로그인',
  '2. Select activated software in Apps': '2. Apps에서 활성화된 소프트웨어 선택',
  '3. Install and Use': '3. 설치 및 사용',
  Home: '홈으로',
  'Generate Offline Activation Code': '오프라인 활성화 코드 생성',
  'Generate Offline Activation Code Complete': '오프라인 활성화 코드 생성 완료',
  'Code generation is complete.': '코드 생성이 완료되었습니다.',
  '1. Copy the downloaded Key file to the corresponding PC.':
    '1. 다운로드 받은 Key 파일을 해당 PC에 복사하세요.',
  '2. Proceed with the License Renewal process.': '2. 라이선스 갱신 절차를 진행하세요.',
  'Download Key File': '키 파일 다운로드',
  'Generate Key File complete': '키 파일 생성 완료',
  'Key File download is complete.': '키 파일 다운로드 완료',
  'Choose File': '파일 선택',
  'Please select a file': '파일을 선택해주세요',
  '2. Please proceed with the remaining steps.': '2. 나머지 절차를 진행하세요.',
  '표시할 앱이 없습니다.': '표시할 앱이 없습니다.',
  'appManuals.downloadHelpText':
    '다운로드 받은 파일은 인터넷 브라우저나 PDF Reader 소프트웨어를 통해서 열람할 수 있습니다.',
  'appManuals.systemRequirements':
    '하드웨어 사양(권장): Intel® Core™ i3급 이상 CPU, 메모리 4 GB 이상, PDF 저장을 위한 100 MB 이상의 여유 저장공간',
  'appManuals.medicalsoftware.helptext': '국가에 따라 의료 소프트웨어 여부가 다를 수 있습니다.',
  '구매 문의': '구매 문의',
  '문의 내용': '문의 내용',
  '문의 하기': '문의 하기',
  '문의 내용을 입력해주세요.': '문의 내용을 입력해주세요.',
  'Customer Country': '고객 국가',
  '핸드폰 번호': '핸드폰 번호',
  '핸드폰 번호를 입력해주세요': '핸드폰 번호를 입력해주세요',
  '핸드폰 번호를 입력해주세요.': '핸드폰 번호를 입력해주세요.',
  '유효한 핸드폰 번호를 입력해주세요.': '유효한 핸드폰 번호를 입력해주세요.',
  // --- eIFU portal UI labels & language names (issue #16) ---
  'show all manuals': '모든 매뉴얼 보기',
  'Checking the latest documents.': '최신 문서를 확인하는 중입니다.',
  'There are no manuals to display.': '표시할 매뉴얼이 없습니다.',
  'Manuals': '매뉴얼',
  'Product Name': '제품명',
  'Language': '언어',
  'Document Name': '문서명',
  'Product': '제품',
  'Revision': '리비전',
  'Document': '문서',
  'Published': '게시일',
  'English': '영어',
  'Korean': '한국어',
  'Japanese': '일본어',
  'German': '독일어',
  'Russian': '러시아어',
  'Chinese (Simplified)': '중국어(간체)',
  'Chinese (Traditional)': '중국어(번체)',
  'Country': '국가',
  'eifuPortalIntro': 'RAY 의료기기 소프트웨어의 전자 사용설명서(eIFU)를 검색하고 다운로드하실 수 있습니다.',
  // 공개 포털 헤더 국가 선택
  'Search': '검색',
  'All countries': '전체 국가',
  'No results': '결과 없음',
  // --- /admin 관리자 콘솔 (한국어) ---
  'eIFU Admin — Country Exceptions': 'eIFU 관리자 — 국가 예외',
  'By default every manual is visible in all countries. Add an exception to hide a product or limit it to specific versions for the selected countries.':
    '기본적으로 모든 매뉴얼은 모든 국가에 노출됩니다. 예외를 추가하면 선택한 국가에서 특정 제품을 숨기거나 노출 버전을 제한할 수 있습니다.',
  'Add exception': '예외 추가',
  'Exception countries': '예외 국가',
  'Select countries': '국가 선택',
  'Select a product': '제품 선택',
  'Exception type': '예외 유형',
  'Hide product entirely': '제품 전체 숨김',
  'Show only selected versions': '선택한 버전만 노출',
  'Visible versions': '노출 버전',
  'Select versions': '버전 선택',
  'Select a product first': '제품을 먼저 선택하세요',
  'Save': '저장',
  'Select at least one country.': '국가를 하나 이상 선택하세요.',
  'Select a product.': '제품을 선택하세요.',
  'Select at least one version.': '버전을 하나 이상 선택하세요.',
  'Save failed': '저장 실패',
  'Delete failed': '삭제 실패',
  'Exceptions': '예외 목록',
  'No exceptions — every manual is visible in all countries.': '예외 없음 — 모든 매뉴얼이 모든 국가에 노출됩니다.',
  'Exception': '예외',
  'Countries': '국가',
  'Hidden': '숨김',
  'Versions': '버전',
  'Delete': '삭제',
  "criticalNotice.badge": "중요 공지",
  "criticalNotice.close": "닫기",
  "Critical notices": "중요 공지",
  "criticalNoticeAdmin.help": "포털에 모달로 표시되는 공지를 추가합니다. 언어별로 내용을 입력하면 방문자는 자신의 언어로, 없으면 영어로 표시됩니다.",
  "criticalNoticeAdmin.needContent": "최소 한 개 언어의 제목 또는 내용을 입력하세요.",
  "Notice title": "공지 제목",
  "Notice message": "공지 내용",
  "Add notice": "공지 추가",
  "Languages": "언어",
  // --- 관리자 탭 + 공지 노출 기간(만료) ---
  "eIFU Admin": "eIFU 관리자",
  "Country exceptions": "국가 예외 관리",
  "Notices": "공지 관리",
  "Display period": "노출 기간",
  "noticeExpiry.days": "{{n}}일",
  "No expiry": "무기한",
  "or": "또는",
  "days": "일",
  "noticeExpiry.hintIndefinite": "삭제하기 전까지 포털에 계속 노출됩니다.",
  "noticeExpiry.hintUntil": "{{date}}에 포털에서 자동으로 숨김 처리됩니다.",
  "Registered notices": "등록된 공지",
  "No notices.": "등록된 공지가 없습니다.",
  "Expires": "노출 종료",
  "Active": "활성",
  "Expired": "만료됨",
  "Indefinite": "무기한",
};

export default ko;
